import { render, staticRenderFns } from "./AllSkusTab.vue?vue&type=template&id=764488cd&scoped=true"
import script from "./AllSkusTab.vue?vue&type=script&lang=ts"
export * from "./AllSkusTab.vue?vue&type=script&lang=ts"
import style0 from "./AllSkusTab.vue?vue&type=style&index=0&id=764488cd&prod&scoped=true&lang=css"
import style1 from "./AllSkusTab.vue?vue&type=style&index=1&id=764488cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764488cd",
  null
  
)

export default component.exports